const ITEMS = [
  "Reaction Videos",
  "Podcasts",
  "Shorts & Reels",
  "Thumbnails",
  "Color Grading",
  "Caption Design",
  "B-Roll Cuts",
  "Channel Branding",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="border-b border-white/10 py-8 md:py-10 overflow-hidden bg-[#000000]">
      <div className="marquee-track">
        {row.map((t, i) => (
          <div key={i} className="flex items-center shrink-0 px-8">
            <span className="font-oswald uppercase text-3xl md:text-5xl tracking-tight text-white/85">{t}</span>
            <span className="ml-8 inline-block w-2 h-2 rounded-full bg-[#00A0E4]" />
          </div>
        ))}
      </div>
    </section>
  );
}
